export default "__VITE_ASSET__2m8bWPXA__"